import list from "../../opciones";

const defaultState = {
  listaPlanes: [],
  Plan_selected: {},

  versiones: list.versiones,
  Version_selected: {},

  Allprestaciones: [],
  prestaciones: [], //list.prestaciones,
  Prestacion_selected: {},

  listaSeleccionados: [],

  unidadesDeMedida: list.unidadesDeMedida,
  Prestadores: list.Prestadores,
  reglas: list.reglas,
  flag: "",

  nombre_plan: "",
  nombre_version: "",

  editar: false,
  contador: 0,

  listaPrestadores: [],
  Prestador_selected: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    //PRESTACIONES
    case "ALTA_PRESTACION":
      return {
        ...state,
        prestaciones: [...state.prestaciones, action.payload],
        Prestacion_selected: {},
      };
    case "EDITAR_PRESTACION":
      return {
        ...state,
        prestaciones: state.prestaciones.map((prestacion) =>
          prestacion.idPrestacion === action.payload.idPrestacion
            ? {
              ...prestacion,
              nombre: action.payload.nombre,
              PrestacionesHijas: action.payload.PrestacionesHijas,
            }
            : prestacion
        ),
      };
    case "CLICK_PRESTACION":
      return {
        ...state,
        Prestacion_selected: action.payload,
      };
    case "CLICK_EDITAR":
      return {
        ...state,
        editar: action.payload,
      };

    case "ADD_PRESTACION_A_PLAN":
      return {
        ...state,
        listaSeleccionados: [...state.listaSeleccionados, action.payload],
        prestaciones: state.prestaciones.filter(function (x) {
          return x.idPrestacion !== action.payload.idPrestacion;
        }),
        Prestacion_selected: {},
      };
    case "DEL_PRESTACION_A_PLAN":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.filter(function (x) {
          return x.idPrestacion !== action.payload.idPrestacion;
        }),
        prestaciones: [...state.prestaciones, action.payload],
        Prestacion_selected: {},
      };
    case "CLICK_PLAN":
      return {
        ...state,
        Plan_selected: action.payload,
        versiones: action.payload.versiones,
      };
    case "SET_FLAG":
      return {
        ...state,
        flag: action.payload,
      };
    case "SET_NOMBRE_PLAN":
      return {
        ...state,
        nombre_plan: action.payload,
      };
    case "CLICK_VERSION":
      return {
        ...state,
        Version_selected: action.payload,
        listaSeleccionados: action.payload.prestaciones,
      };
    case "SET_NOMBRE_VERSION":
      return {
        ...state,
        nombre_version: action.payload,
      };
    case "ADD_REGLA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? { ...prestacion, reglas: action.payload }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: action.payload,
        },
      };
    case "EDIT_REGLA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.id
                  ? {
                    ...r,
                    tipo: action.payload.tipo,
                    nombre: action.payload.nombre,
                    cantidad: action.payload.cantidad,
                    porMascota: action.payload.porMascota,
                    porMascotas: action.payload.porMascotas,
                    prioridad: action.payload.prioridad,
                    tituloPersonalizado: action.payload.tituloPersonalizado,
                    unidadMedida1: action.payload.unidadMedida1,
                    unidadMedida2: action.payload.unidadMedida2,
                    PorPrestadores: action.payload.PorPrestadores,
                    texto: action.payload.texto,
                    rango: action.payload.rango,
                    listadoExcepciones: action.payload.listadoExcepciones,
                    con_corrimientos_vigencias:
                      action.payload.con_corrimientos_vigencias,
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.id
              ? {
                ...r,
                tipo: action.payload.tipo,
                nombre: action.payload.nombre,
                cantidad: action.payload.cantidad,
                porMascota: action.payload.porMascota,
                porMascotas: action.payload.porMascotas,
                prioridad: action.payload.prioridad,
                tituloPersonalizado: action.payload.tituloPersonalizado,
                unidadMedida1: action.payload.unidadMedida1,
                unidadMedida2: action.payload.unidadMedida2,
                PorPrestadores: action.payload.PorPrestadores,
                texto: action.payload.texto,
                rango: action.payload.rango,
                listadoExcepciones: action.payload.listadoExcepciones,
                con_corrimientos_vigencias:
                  action.payload.con_corrimientos_vigencias,
              }
              : r
          ),
        },
      };
    case "CAMBIAR_DONDE_COMPUTA_TOPE":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion == action.payload.idPrestacion
            ? {
              ...prestacion,
              compartir_tope_con: action.payload.compartir_tope_con,
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          compartir_tope_con: action.payload.compartir_tope_con,
        },
      };
    case "CAMBIAR_TAGS":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion == action.payload.idPrestacion
            ? {
              ...prestacion,
              tags: action.payload.tags,
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          tags: action.payload.tags,
        },
      };
    case "CAMBIAR_ORDER_MENU":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion == action.payload.idPrestacion
            ? {
              ...prestacion,
              order: action.payload.order,
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          order: action.payload.order,
        },
      };
    case "CAMBIAR_SUBTITULO":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion == action.payload.idPrestacion
            ? {
              ...prestacion,
              subtitulo: action.payload.subtitulo,
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          subtitulo: action.payload.subtitulo,
        },
      };
    case "EDIT_TIPO_REGLA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.id
                  ? {
                    ...r,
                    tipo: action.payload.tipo,
                    nombre: action.payload.nombre,
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.id
              ? {
                ...r,
                tipo: action.payload.tipo,
                nombre: action.payload.nombre,
              }
              : r
          ),
        },
      };
    case "EDIT_TIPO_REGLA_HIJA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.parentID
                  ? {
                    ...r,
                    reglasHijas: r.reglasHijas.map((rh) =>
                      rh.id === action.payload.id
                        ? {
                          ...rh,
                          tipo: action.payload.tipo,
                          nombre: action.payload.nombre,
                        }
                        : rh
                    ),
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.parentID
              ? {
                ...r,
                reglasHijas: r.reglasHijas.map((rh) =>
                  rh.id === action.payload.id
                    ? {
                      ...rh,
                      tipo: action.payload.tipo,
                      nombre: action.payload.nombre,
                    }
                    : rh
                ),
              }
              : r
          ),
        },
      };
    case "EDIT_REGLA_HIJA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.parentID
                  ? {
                    ...r,
                    reglasHijas: r.reglasHijas.map((rh) =>
                      rh.id === action.payload.id
                        ? {
                          ...rh,
                          tipo: action.payload.tipo,
                          nombre: action.payload.nombre,
                          cantidad: action.payload.cantidad,
                          porMascota: action.payload.porMascota,
                          porMascotas: action.payload.porMascotas,
                          prioridad: action.payload.prioridad,
                          tituloPersonalizado:
                            action.payload.tituloPersonalizado,
                          unidadMedida1: action.payload.unidadMedida1,
                          unidadMedida2: action.payload.unidadMedida2,
                          PorPrestadores: action.payload.PorPrestadores,
                          texto: action.payload.texto,
                          rango: action.payload.rango,
                          listadoExcepciones:
                            action.payload.listadoExcepciones,
                          con_corrimientos_vigencias:
                            action.payload.con_corrimientos_vigencias,
                        }
                        : rh
                    ),
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.parentID
              ? {
                ...r,
                reglasHijas: r.reglasHijas.map((rh) =>
                  rh.id === action.payload.id
                    ? {
                      ...rh,
                      tipo: action.payload.tipo,
                      nombre: action.payload.nombre,
                      cantidad: action.payload.cantidad,
                      porMascota: action.payload.porMascota,
                      porMascotas: action.payload.porMascotas,
                      prioridad: action.payload.prioridad,
                      tituloPersonalizado:
                        action.payload.tituloPersonalizado,
                      unidadMedida1: action.payload.unidadMedida1,
                      unidadMedida2: action.payload.unidadMedida2,
                      PorPrestadores: action.payload.PorPrestadores,
                      texto: action.payload.texto,
                      rango: action.payload.rango,
                      listadoExcepciones: action.payload.listadoExcepciones,
                      con_corrimientos_vigencias:
                        action.payload.con_corrimientos_vigencias,
                    }
                    : rh
                ),
              }
              : r
          ),
        },
      };
    case "ADD_REGLA_HIJA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.parentID
                  ? {
                    ...r,
                    reglasHijas: r.reglasHijas.concat(action.payload),
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.parentID
              ? {
                ...r,
                reglasHijas: r.reglasHijas.concat(action.payload),
              }
              : r
          ),
        },
      };
    case "DEL_REGLA_HIJA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.map((r) =>
                r.id === action.payload.parentID
                  ? {
                    ...r,
                    reglasHijas: r.reglasHijas.filter(function (r) {
                      return r.id !== action.payload.id;
                    }),
                  }
                  : r
              ),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.map((r) =>
            r.id === action.payload.parentID
              ? {
                ...r,
                reglasHijas: r.reglasHijas.filter(function (r) {
                  return r.id !== action.payload.id;
                }),
              }
              : r
          ),
        },
      };
    case "DEL_REGLA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? {
              ...prestacion,
              reglas: state.Prestacion_selected.reglas.filter(function (r) {
                return r.id !== action.payload;
              }),
            }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: state.Prestacion_selected.reglas.filter(function (r) {
            return r.id !== action.payload;
          }),
        },
      };
    case "AUMENTAR_PRIORIDAD_REGLA":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? { ...prestacion, reglas: action.payload }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: action.payload,
        },
      };
    case "PEGAR_REGLAS_DESDE_PORTAPAPELES":
      return {
        ...state,
        listaSeleccionados: state.listaSeleccionados.map((prestacion) =>
          prestacion.idPrestacion === state.Prestacion_selected.idPrestacion
            ? { ...prestacion, reglas: action.payload }
            : prestacion
        ),
        Prestacion_selected: {
          ...state.Prestacion_selected,
          reglas: action.payload,
        },
      };
    case "PEGAR_PRESTACION_DESDE_PORTAPAPELES":
      return {
        ...state,
        listaSeleccionados: [
          ...state.listaSeleccionados.filter(p => p.idPrestacion != action.payload.idPrestacion), 
          action.payload
        ],
        prestaciones: state.prestaciones.filter(function (x) {
          return x.idPrestacion !== action.payload.idPrestacion;
        }),
      };
    case "ALTA_PLAN":
      return {
        ...state,
        listaPlanes: [...state.listaPlanes, action.payload],
      };
    case "ALTA_VERSION":
      return {
        ...state,
        listaPlanes: state.listaPlanes.map((p) => {
          return p.idPlan === state.Plan_selected.idPlan
            ? {
              ...p,
              versiones: [...p.versiones, action.payload],
            }
            : p;
        }),
      };
    case "SET_PRESTACIONES":
      return {
        ...state,
        prestaciones: action.payload,
        Allprestaciones: action.payload,
      };
    case "SET_PLANES":
      return {
        ...state,
        listaPlanes: action.payload,
      };
    case "CLEAN_PRESTACIONES_SELECTED":
      return {
        ...state,
        listaSeleccionados: [],
      };
    case "CLEAN_PLAN_SELECTED":
      return {
        ...state,
        Plan_selected: {},
      };
    case "CLEAN_ALL":
      return {
        ...state,
        Plan_selected: {},
        listaSeleccionados: [],
        Prestacion_selected: {},
      };

    //PRESTADORES (falta combinar reducers)
    case "SET_PRESTADORES":
      return {
        ...state,
        listaPrestadores: action.payload,
      };
    case "GUARDAR_PRESTADOR_OK":
      return {
        ...state,
        Prestador_selected: action.payload,
        listaPrestadores: state.listaPrestadores.map((item) =>
          item._id === action.payload._id ? action.payload : item),
      };
    case "CLICK_PRESTADOR":
      return {
        ...state,
        Prestador_selected: action.payload,
      };
    case "ADD_PRESTACION_A_PRESTADOR":
      if (state.Prestador_selected.prestacionprecio.some((item) =>
        item.idprestacion === action.payload.idprestacion)) return state;
      return {
        ...state,
        Prestador_selected: {
          ...state.Prestador_selected,
          prestacionprecio: [
            ...state.Prestador_selected.prestacionprecio,
            action.payload,
          ],
        },
      };
    case "DEL_PRESTACION_A_PRESTADOR":
      return {
        ...state,
        Prestador_selected: {
          ...state.Prestador_selected,
          prestacionprecio: [
            ...state.Prestador_selected.prestacionprecio.filter(function (p) {
              return p.idprestacion !== action.payload;
            }),
          ],
        },
      };
    case "EDIT_PRESTACION_A_PRESTADOR":
      return {
        ...state,
        Prestador_selected: {
          ...state.Prestador_selected,
          prestacionprecio: [
            ...state.Prestador_selected.prestacionprecio.map((p) => {
              return p.idprestacion === action.payload.idprestacion
                ? action.payload
                : p;
            }),
          ],
        },
      };

    default:
      return state;
  }
};
